import { Modal } from "barte-design-system";
import { RiErrorWarningLine } from "react-icons/ri";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleConfirmModal: () => void;
  title: string;
  children?: React.ReactNode;
  yesNoText?: boolean;
  isSubmitting?: boolean;
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  handleConfirmModal,
  children,
  title,
  yesNoText = false,
  isSubmitting = false,
}: ModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      footer={{
        primaryButton: {
          id: title.toLowerCase().includes("excluir") ? "excluir_cobrança" : undefined,
          children: yesNoText ? "Sim" : "Confirmar",
          onClick: handleConfirmModal,
          loading: isSubmitting,
          disabled: isSubmitting,
        },
        secondaryButton: {
          children: yesNoText ? "Não" : "Cancelar",
          onClick: onClose,
          variant: "outline",
        },
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
        <RiErrorWarningLine size={24} color="#FAAD14" style={{ flexShrink: 0 }} />
        <div>{children}</div>
      </div>
    </Modal>
  );
};

export { ConfirmationModal };
